import { useState } from "react";
import { Link } from "react-router-dom";
import { api, getErrorMessage } from "@/lib/api";
import { Lightning, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] font-body flex items-center justify-center p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-12">
          <Lightning weight="fill" size={22} className="text-[#FF2A2A]" />
          <span className="font-heading font-black text-xl tracking-tight">RECRUITFLOW</span>
        </div>

        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-3">
          Reset password
        </div>
        <h1 className="font-heading font-black tracking-tight text-4xl sm:text-5xl mb-6 leading-[1.05]">
          Forgot your<br />password?
        </h1>
        <p className="text-sm text-zinc-500 mb-10">
          Enter the email you use to log in. We'll send you a link to set a new password.
        </p>

        {sent ? (
          <div className="border border-emerald-500 bg-emerald-50 text-emerald-900 text-sm px-4 py-4 rounded-sm" data-testid="forgot-sent">
            <div className="font-medium mb-1">Check your inbox</div>
            <div className="text-xs">If that email is in our system, a reset link is on its way. The link expires in 1 hour.</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-form">
            <div>
              <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2">
                Email
              </label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-zinc-200 px-4 py-3 text-sm rounded-sm focus:outline-none focus:border-zinc-950 transition-colors"
                placeholder="you@company.com"
                autoFocus
              />
            </div>

            {error && (
              <div className="border border-[#FF2A2A] bg-red-50 text-[#B91C1C] text-sm px-4 py-3 rounded-sm">
                {error}
              </div>
            )}

            <button
              data-testid="forgot-submit-btn"
              type="submit"
              disabled={submitting}
              className="w-full bg-zinc-950 text-white py-3.5 rounded-sm font-medium hover:bg-zinc-800 transition-colors disabled:opacity-50"
            >
              {submitting ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-6 text-sm text-zinc-500">
          <Link to="/login" className="inline-flex items-center gap-1.5 text-zinc-950 underline underline-offset-4 hover:no-underline" data-testid="back-to-login">
            <ArrowLeft size={14} weight="bold" /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
